module.exports = __webpack_public_path__ + "static/media/groovy.fa4628c6.svg";